module.exports = __webpack_public_path__ + "img/screen_test.aeb37966.png";